import { AppRoutes } from './app_routes';

const isUnder = (pathname: string, route: string): boolean =>
  pathname === route || pathname.startsWith(`${route}/`);

/**
 * Live input screen: no tutorial bubble may cover it, nothing must block a scoring key
 * (VOL-141, "rien ne bloque la saisie"), and it has its own sync indicator.
 */
export function isLiveInputPath(pathname: string): boolean {
  return isUnder(pathname, AppRoutes.match.input);
}

// Screens whose input bar is fixed to the bottom of the screen. A new one goes here, so that
// floating layers (cookie banner) keep off it.
const FIXED_BOTTOM_BAR_ROUTES: readonly string[] = [AppRoutes.match.input, AppRoutes.matchReview.main];

/** Whether the screen keeps a bar of its own at the bottom, which nothing may cover. */
export function hasFixedBottomBar(pathname: string): boolean {
  return FIXED_BOTTOM_BAR_ROUTES.some((route) => isUnder(pathname, route));
}
